import React from 'react';
import { ShoppingCart } from 'lucide-react';
import { useTheme } from '../../core/ui/ThemeContext';
import { useLanguage } from '../../core/i18n/LanguageContext';

const CartEmptyState = () => {
  const { isDarkMode } = useTheme();
  const { t } = useLanguage();

  return (
    <div className="relative group">
      {/* Liquid Glass Background */}
      <div className={`absolute inset-0 ${isDarkMode
        ? 'bg-gradient-to-br from-gray-900/30 via-gray-800/20 to-gray-900/30 border border-white/20 backdrop-blur-2xl shadow-[0_8px_32px_rgba(0,0,0,0.4)]'
        : 'bg-white border border-slate-200 shadow-sm'
      } rounded-3xl`}></div>
      <div className={`absolute inset-0 ${isDarkMode
        ? 'bg-gradient-to-t from-white/5 via-transparent to-white/10'
        : ''
      } rounded-3xl`}></div>

      {/* Glass Particles */}
      <div className={`absolute top-6 right-8 w-2 h-2 bg-white/20 rounded-full animate-pulse ${isDarkMode ? '' : 'hidden'}`}></div>
      
      <div className="relative p-12">
        <div className="text-center">
          {/* Liquid Glass Empty State Icon */}
          <div className="relative group/empty mb-6">
            <div className={`absolute inset-0 rounded-3xl blur-sm ${isDarkMode ? 'bg-gradient-to-br from-white/20 via-white/10 to-transparent' : 'hidden'}`}></div>
            <div className={`relative w-16 h-16 rounded-3xl flex items-center justify-center border mx-auto ${
              isDarkMode
                ? 'bg-gradient-to-br from-blue-600/60 via-blue-700/50 to-blue-800/60 backdrop-blur-xl shadow-[0_8px_32px_rgba(59,130,246,0.3),inset_0_1px_0_rgba(255,255,255,0.3)] border-white/20'
                : 'bg-brand/10 border-brand/20'
            }`}>
              <ShoppingCart className={`w-8 h-8 ${isDarkMode ? 'text-white/90 drop-shadow-lg' : 'text-brand'}`} />
              <div className={`absolute top-2 left-2 w-4 h-4 bg-white/30 rounded-full blur-sm ${isDarkMode ? '' : 'hidden'}`}></div>
            </div>
          </div>
          <h3 className={`text-lg font-bold ${isDarkMode ? 'text-white drop-shadow-lg' : 'text-slate-900'} mb-3`}>{t('cart.empty')}</h3>
          <p className={`${isDarkMode ? 'text-white/70 drop-shadow-sm' : 'text-slate-500'} max-w-sm mx-auto`}>{t('cart.emptyDesc')}</p>
        </div>
      </div>
    </div>
  );
};

export default CartEmptyState;